import { useState } from 'react';
import styles from './index.module.sass';
import classnames from 'classnames/bind';
import { VALIDATE_STATUS } from 'config';
const cx = classnames.bind(styles);

const FormInput = ({
  type = 'text',
  value,
  status,
  id,
  placeHolder,
  errorMessage,
  maxLength,
  onChange = () => {},
  onFocus = () => {},
  onBlur = () => {},
  onKeyPress = () => {},
}) => {
  const [isOnComposition, setIsOnComposition] = useState(false);

  const onCompositionStart = () => setIsOnComposition(true);

  const onCompositionUpdate = () => setIsOnComposition(true);

  const onCompositionEnd = () => setIsOnComposition(true);

  /**
   * 組合性輸入法會在 onCompositionEnd 才會顯示真的要輸入的文字
   * 所以大小寫轉換也要在 onCompositionEnd 才能改變，在 composition 時做 toUpperCase 會導致 composition 中斷
   * 這邊採用一個比較暴力的做法我只在 onCompositionEnd 後才做加工處理
   * ref: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
   */

  const onTextChange = value => {
    if (!isOnComposition && id === 'plateNumber') {
      value = value.toUpperCase();
    }

    onChange(value);
  };

  const message = () => {
    switch (status) {
      case VALIDATE_STATUS.INIT:
      case VALIDATE_STATUS.VALID:
        return '必填';
      case VALIDATE_STATUS.INVALID:
        return errorMessage || '必填';
      default:
        return '';
    }
  };

  const inputClass = cx({
    [id]: true,
    error: status === VALIDATE_STATUS.INVALID,
  });

  const requireClass = cx({
    required: true,
    error: status === VALIDATE_STATUS.INVALID,
  });
  return (
    <label className={styles['form-input']}>
      <input
        type={type}
        className={inputClass}
        value={value}
        maxLength={maxLength}
        placeholder={placeHolder}
        onCompositionStart={onCompositionStart}
        onCompositionUpdate={onCompositionUpdate}
        onCompositionEnd={onCompositionEnd}
        onChange={e => onTextChange(e.target.value)}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyPress={e => onKeyPress(e)}
      />
      <div className={requireClass}>{message()}</div>
    </label>
  );
};

export default FormInput;
